"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DISCARD_ORDER_RATING_NOTIFICATION = void 0;
const client_1 = require("@apollo/client");
exports.DISCARD_ORDER_RATING_NOTIFICATION = client_1.gql `
mutation discardOrderRatingNotification($id: ID!) {
  discardOrderRatingNotification(id: $id)
}
`;
